// extracted by mini-css-extract-plugin
export default {"logoBlock":"_KKZKYG5GCrzTMfac1AD","errorHeading":"JJPf8R3yaqx4BqA_s8DB","errorMessage":"CLDhx5yGsaFwvaD7e8Xw"};